<div class="version-dropdown" [class.disabled]="disabled()">
  <!-- Version Selector Button -->
  <button 
    class="version-selector-btn"
    (click)="toggleDropdown()"
    [disabled]="disabled()"
    [attr.aria-expanded]="isOpen()"
    [attr.aria-haspopup]="true"
  >
    <span class="version-text">Ver: {{ currentVersion() }}</span>
    <mat-icon class="dropdown-arrow" [class.open]="isOpen()">arrow_drop_down</mat-icon>
  </button>

  <!-- Custom Dropdown -->
  <div 
    class="dropdown-menu" 
    [class.open]="isOpen()"
    [attr.aria-hidden]="!isOpen()"
    [style.display]="isOpen() ? 'block' : 'none'"
    role="menu"
  >
    <!-- New Version Button -->
    <div 
      class="dropdown-item new-version-btn" 
      (click)="createNewVersion()" 
      (keydown)="onKeyDown($event, 'createNewVersion')"
      role="menuitem"
      tabindex="0"
    >
      <div class="new-version-content">
        <mat-icon class="add-icon">add</mat-icon>
        <span class="new-version-text">New Version</span>
      </div>
    </div>

    <!-- Divider -->
    <div class="dropdown-divider"></div>

    <!-- Version List Items -->
    @for (version of projectVersions(); track version.versionId) {
      <!-- Head Version Special Item -->
      @if (isHeadVersion(version)) {
        <div 
          class="dropdown-item head-version"
          [class.selected]="isSelectedVersion(version)"
          (click)="selectVersion(version)"
          (keydown)="onKeyDown($event, 'selectVersion', version)"
          role="menuitem"
          tabindex="0"
        >
          <div class="version-content">
            <span class="head-version-text">Head Version</span>
            @if (isSelectedVersion(version)) {
              <mat-icon class="check-icon">check</mat-icon>
            }
          </div>
        </div>
      }

      <!-- Regular Version Items -->
      @if (!isHeadVersion(version)) {
        <div 
          class="dropdown-item version-item"
          [class.selected]="isSelectedVersion(version)"
          (click)="selectVersion(version)"
          (keydown)="onKeyDown($event, 'selectVersion', version)"
          role="menuitem"
          tabindex="0"
        >
          <div class="version-content">
            <div class="version-info">
              <span class="version-number">{{ getVersionDisplay(version) }}</span>
              <span class="version-timestamp">from {{ formatTimestamp(version.createdAt) }}</span>
              @if (version.message) {
                <span class="version-message" [matTooltip]="version.message">{{ version.message }}</span>
              }
            </div>
            @if (isSelectedVersion(version)) {
              <mat-icon class="check-icon">check</mat-icon>
            }
          </div>
        </div>
      }
    }

    <!-- No versions message -->
    @if (projectVersions().length === 0) {
      <div class="dropdown-item no-versions">
        <span class="no-versions-text">{{ emptyStateMessage() }}</span>
      </div>
    }
  </div>

  <!-- Backdrop -->
  @if (isOpen()) {
    <div 
      class="dropdown-backdrop"
      (click)="closeDropdown()"
      (keydown)="onKeyDown($event, 'closeDropdown')"
      tabindex="0"
    ></div>
  }
</div>
